import MobileHome from './MobileHome';
import WebHome from './WebHome';

export default process.env.REACT_APP_BUILD_FOR === 'mobile'
  ? MobileHome
  : WebHome;
